import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { NATIVE_APP_HELPER } from 'constants/native_app_helper.constants'

import styles from './index.module.scss'

interface Props {
  link: string
  rootDomain?: string
  children: React.ReactNode
}

export const NativeThumbnailLink: FC<Props> = ({
  link,
  rootDomain,
  children
}) => {
  // Note :
  // SOLID_SPORT.IS_SOLIDSPORT_DOMAIN is used to check if the app
  // is running in the Solid Sport domain or not
  if (rootDomain && !NATIVE_APP_HELPER.SOLID_SPORT_APP.IS_CURRENT_DOMAIN) {
    return (
      <a
        target="_blank"
        href={`https://${rootDomain}${link}`}
        rel="noopener noreferrer"
        className={styles.BroadcastThumbnailLink}
      >
        {children}
      </a>
    )
  }
  return (
    <Link to={link} className={styles.BroadcastThumbnailLink}>
      {children}
    </Link>
  )
}
